export default __webpack_public_path__ + "static/android-button-dc68053f1bdf54d512154c36d7791d03.png";